// extracted by mini-css-extract-plugin
module.exports = {"key-moment":"styles-module__key-moment___3mjGV","play":"styles-module__play___2gz4e"};